import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80c7765a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rpp-item" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Загрузка РПП...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-red-400" }, "Произошла ошибка при загрузке РПП", -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "rpp-item__header" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "rpp-item__body"
}
const _hoisted_13 = { class: "mt-2 font-semibold" }
const _hoisted_14 = { class: "mt-2 font-semibold" }
const _hoisted_15 = { class: "rpp-item__actions" }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_modal = _resolveComponent("modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_submit)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          title: "Подтверждение РПП",
          loading: _ctx.state.is_submit_loading,
          onCancel: _ctx.toggleChangeStatus,
          onConfirm: _ctx.submitRpp
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_textarea, {
              disabled: _ctx.state.is_submit_loading,
              autoheight: "",
              rows: 4,
              placeholder: "Комментарий",
              value: _ctx.state.comment,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event))
            }, null, 8, ["disabled", "value"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createVNode(_component_loader, { class: "primary mt-1" })
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_the_button, {
                    class: "primary small mt-2",
                    onClick: _ctx.loadRPP
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перезагрузить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_page_title, {
                title: `Просмотр РПП (ID: ${_ctx.rpp_id})`
              }, null, 8, ["title"]),
              _createVNode(_component_cheap, { class: "small ml-5" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.rpp?.status_name || 'Нет статуса'), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.state.rpp)
                ? (_openBlock(), _createBlock(_component_cheap, {
                    key: 0,
                    class: "small mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.rpp.created_at) || '-'), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.rpp && _ctx.state.rpp.ftl_order_id)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: `/ftl-orders/${_ctx.state.rpp.ftl_order_id}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_the_button, { class: "text small primary" }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createTextVNode("Открыть FTL заказ ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              (_ctx.isOnEditStatus)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: `/rpp/edit/${_ctx.rpp_id}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_the_button, { class: "text small primary" }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _createTextVNode("Редактировать ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, { to: "/rpp/edit" }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_button, { class: "second small text" }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createTextVNode(" Назад ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.state.rpp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("p", null, "Дата РПП: " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.rpp.pbs_date) || '-'), 1),
                _createElementVNode("p", null, "Дата АВР: " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.rpp.act_date) || '-'), 1),
                _createElementVNode("p", null, "Номер АВР: " + _toDisplayString(_ctx.state.rpp.act_number || '-'), 1),
                _createElementVNode("p", null, "Компания: " + _toDisplayString(_ctx.state.rpp.company_name || '-'), 1),
                _createElementVNode("p", null, "Пользователь: " + _toDisplayString(_ctx.state.rpp.user_name || '-'), 1),
                _createElementVNode("p", null, "Дата создания заказа: " + _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.rpp?.order_created_at) || '-'), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.getCostPriceTitle) + " " + _toDisplayString(_ctx.state.rpp.cost_price || '-'), 1),
                _createElementVNode("p", null, "Номер FTL-заказа: " + _toDisplayString(_ctx.state.rpp.ftl_order_id || '-'), 1),
                _createElementVNode("p", null, "Кем одобрено: " + _toDisplayString(_ctx.state.rpp.approver?.name || '-'), 1),
                _createElementVNode("p", null, "Дата оборота: " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.rpp.turnover_date) || '-'), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, "Направление (полное): " + _toDisplayString(_ctx.getFullPath()), 1),
          _createElementVNode("p", null, "Статья ДДС: " + _toDisplayString(_ctx.state.rpp.cash_flow_name || '-'), 1),
          _createElementVNode("p", _hoisted_13, [
            (_ctx.state.rpp.prices)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Выставлено клиенту без НДС: " + _toDisplayString(_ctx.state.rpp.prices.paid_price_without_nds), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Выставлено клиенту без НДС: -")
                ], 64))
          ]),
          _createElementVNode("p", _hoisted_14, [
            (_ctx.state.rpp.prices)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Наценка: " + _toDisplayString(_ctx.roundTo(_ctx.state.rpp.prices.profitability_price)) + " %", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Наценка: -")
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_15, [
            (
                        _ctx.isOnInspectionHeadTransportStatus && _ctx.state.is_head_of_transport_department
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_the_button, {
                    class: "primary text small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleChangeStatus('confirmed')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Подтвердить ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_the_button, {
                    class: "primary text small ml-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleChangeStatus('denied')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Отказать ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.isOnApprovedStatus && _ctx.state.is_accountant)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 1,
                  class: "primary text small mr-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleChangeStatus('completed')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Завершить ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}